<template >
    <div class="excavate clearfix">
        <div class="excavate-title"> </div>
        <div class="excavate-cont">
            <div class="excavate-left-nav">
                <div class="left-nav">
                    <div class="excavate-left-nav-header"><span>分析方法</span></div>
                    <div class="excavate-left-nav-list">
                        <ul>
                            <li :class="{ 'excavate-active': navIndex == item.type }" 
                                v-for="item in leftNav" :key="item.type" 
                                @click="leftNavTab(item.type)" >{{item.value}}</li>
                        </ul>
                    </div>
                    <div class="excavate-left-nav-header"><span>网络药理学</span></div>
                    <div class="excavate-left-nav-list">
                        <ul>
                            <li :class="{ 'excavate-active': navIndex == item.type }" 
                                v-for="item in pharmacologyNav" :key="item.type" 
                                @click="leftNavTab(item.type)" >{{item.value}}</li>
                        </ul>
                    </div>
                </div>
                
            </div>
            <div class="excavate-info">
                <excavatePage @leftNavTab='leftNavTab' v-if='navIndex==0'></excavatePage>
                <excavateStatistics v-else-if='navIndex==1'></excavateStatistics>
                <excavateCluster v-else-if='navIndex==2'></excavateCluster>
                <excavateKM v-else-if='navIndex==3'></excavateKM>
                <excavateAssociation v-else-if='navIndex==4'></excavateAssociation>
                 <excavateRelevance v-else-if='navIndex==5'></excavateRelevance>
                <excavateComplex v-else-if='navIndex==6'></excavateComplex>
                <excavateCheck v-else-if='navIndex==7'></excavateCheck>
                <excavateBayes v-else-if='navIndex==8'></excavateBayes>
                <excavateMutual  v-else-if='navIndex==9'></excavateMutual>
                <excavateFactor v-else-if='navIndex==10'></excavateFactor> 
            </div>
        </div>
        <Toast></Toast>
    </div>
</template>
<script>
// import echartData from '../components/excavate/statistics/data.js';

import {mapState,mapMutations,mapActions} from 'vuex'
import excavatePage from './excavate/excavate_page.vue'
// 统计分析
import excavateStatistics from './excavate/excavate_statistics.vue'
// 层次聚类
import excavateCluster from './excavate/excavate_cluster.vue'
// KM聚类
import excavateKM from './excavate/excavate_KM.vue'
//社团分析
import excavateAssociation from './excavate/excavate_association.vue'
//关联分析
import excavateRelevance from './excavate/excavate_relevance.vue'
//复杂网络分析
import excavateComplex from './excavate/excavate_complex.vue'
// 卡方检验
import excavateCheck from './excavate/excavate_check.vue'
// 贝叶斯
import excavateBayes from './excavate/excavate_bayes.vue'
// 互信息法
import excavateMutual from './excavate/excavate_mutual.vue'
// 因子分析
import excavateFactor from './excavate/excavate_factor.vue' 
import Toast from '../components/ui-kit/toast.vue'
export default {
    components: {
        excavatePage,
        excavateStatistics,
        excavateCluster,
        excavateKM,
        excavateAssociation,
        excavateRelevance,
        excavateComplex,
        excavateCheck,
        excavateBayes,
        excavateMutual,
        excavateFactor, 
        Toast
    },
    data() {
        return {
            leftNav: [
                {
                    value:'统计分析',
                    type:1,
                },
                {
                    value:'层次聚类',
                    type:2,
                },
                {
                    value:'K-Means聚类',
                    type:3,
                },
                {
                    value:'社团分析',
                    type:4,
                },
                {
                    value:'关联分析',
                    type:5,
                },
                {
                    value:'复杂网络分析',
                    type:6,
                },
                {
                    value:'卡方检验',
                    type:7,
                },
                {
                    value:'贝叶斯',
                    type:8,
                },
                {
                    value:'互信息法',
                    type:9,
                },
                {
                    value:'因子分析',
                    type:10,
                },
            ],
            pharmacologyNav:[
                {
                    value:'GO功能富集分析',
                    type:11,
                },
                {
                    value:'KEGG信号通路富集分析',
                    type:12,
                },
                // {
                //     value:'PPI',
                //     type:13,
                // },
            ],
            navIndex:this.$route.query.navType||0,

        }
    },
    computed: {
        
    },
    mounted () {
        this.leftNavTab(this.navIndex)
        this.$store.state.excavate.isShowEacht = false;
    },
    methods: {
        ...mapMutations(['seteEchartData','setModelTitle']),
        leftNavTab(type) { 
            if(type&&type!=1){
                this.$store.state.excavate.isShowEacht = false;
            }
            this.navIndex = type;
        },
    },
}
</script>
<style lang="less">
    @import url('../css/excavate/index.less');
</style>